<template>
  <div
    :class="
      isActive ? 'desktopFullScreenOverlay active' : 'desktopFullScreenOverlay'
    "
    id="desktopFullScreenOverlay"
    ref="desktopFullScreenOverlay"
  >
    <component :is="component" :data="data">
      <template v-slot:crossButton>
        <div
          name=""
          v-if="data.isFullScreen"
          class="closeButton"
          @click="close"
        >
          <fa-icon :icon="['far', 'times-circle']"></fa-icon>
        </div>
      </template>
      <template v-slot:backToTopButton>
        <div
          name="backToTopButton"
          v-if="data.isFullScreen"
          :style="!isBackButtonVisible?'opacity:0;pointer-events:none;':''"
          class="footerContainer"
          @click="goBackToTop"
        >
          {{$t('Back to top')}}
        </div>
      </template>
    </component>
  </div>
</template>

<script>
import "../scss/desktop-full-screen-overlay.css";
import biographiesContent from "./biograhpies-content";
import resourceContent from "./resource-content";
import isThisForMe from "./is-this-for-me";
import speakerPresentation from "./speakerPresentation";

export default {
  components: {
    biographiesContent,
    isThisForMe,
    resourceContent,
    speakerPresentation
  },
  created() {
    window.addEventListener("openDesktopOverlay", this.openDesktopOverlay);
  },
  data() {
    return {
      data: null,
      component: null,
      isActive: false,
      isBackButtonVisible:false
    };
  },
  methods: {
    openDesktopOverlay(e) {
      this.component = e.detail.component;
      this.data = e.detail.data;
      this.isActive = true;
      this.$nextTick(() => {
        this.resize();
      });
    },
    close() {
      this.isActive = false;
      setTimeout(() => {
        this.data = null;
        this.component = null;
      }, 500);
      this.$root.$emit('playVideo') 
    },
    goBackToTop() {
      this.$refs.desktopFullScreenOverlay.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    resize(){
      if(this.$refs.desktopFullScreenOverlay.scrollHeight>window.innerHeight){
        this.isBackButtonVisible=true
      }
      else{
        this.isBackButtonVisible=false
      }
    }
  },
};
</script>